export const FALLBACK_KEY = 'fallback';